import AppConsts from "./appconst";

var abp = window.abp;

export function L(key, ...others) {
  let localizationSourceName =
    AppConsts.localization.defaultLocalizationSourceName;
  return abp.localization.localize(key, localizationSourceName, ...others);
}

export function isGranted(permissionName) {
  return abp.auth.isGranted(permissionName);
}

export function capitalizeFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
